import React from "react";
import { LoadPanel } from "devextreme-react/load-panel";

interface Props {
	message?: string;
	color?: string;
	position?: {[of: string]: string};
	visible?: boolean;
}

const LoadingOverlay: React.FC<Props> = ({message, color, position, visible = true}: Props) => {
	message = message ? message : "Loading...";
	color = color ? color : "rgba(255,255,255,0.5)";

	if (position) return <LoadPanel width="300" shadingColor={color} visible={visible} message={message} position={position} showIndicator shading showPane />;
	return <LoadPanel width="300" shadingColor={color} visible={visible} message={message} showIndicator shading showPane />;
};

export default LoadingOverlay;
